export function isWeixin() {
    var ua = navigator.userAgent.toLowerCase();
    if( ua.match(/MicroMessenger/i)=="micromessenger") {
		return true;
	} else {
        return false;
    }
}

export function isWxwork() {
    var ua = navigator.userAgent.toLowerCase();
    if( (ua.match(/MicroMessenger/i)=="micromessenger") && (ua.match(/wxwork/i) == 'wxwork') ) {
        return true;
	} else {
        return false;
    }
}


export function isAlipay() {
    var ua = navigator.userAgent.toLowerCase();
    if(ua.match(/Alipay/i)=="alipay") {
        return true;
    }
    else {
        return false;
    }
}

export function isZa() {
    var ua = navigator.userAgent;

    if(ua.indexOf('ZhongAnWebView')>=0) {
        return true;
    }
    else {
        return false;
    }
}

export function isMiniprogram(){
    var ua = navigator.userAgent.toLowerCase();
    let bool = false;
    if(ua.match(/MicroMessenger/i) == "micromessenger") {
        return window.__wxjs_environment === 'miniprogram';
    }
    return bool;
}

export function getSystem() {
    var uaInfo = navigator.userAgent;
    var agents = ["Android", "iPhone", "iPad",];
    var flag = "pc";
    for (var i = 0; i < agents.length; i++) {
        if (uaInfo.indexOf(agents[i]) > 0) {
            if(i == 0){
                flag = 'android';
            }else if(i == 1 || i == 2){
                flag = 'ios';
            }
            break;
        }
    }
    return flag;
}

export function isApple() {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    return isiOS;
}

export function getWindowWidth() {
    var winWidth = 0;

    if (window.innerWidth)
        winWidth = window.innerWidth;
    else if ((document.body) && (document.body.clientWidth))
        winWidth = document.body.clientWidth;
    if (document.documentElement && document.documentElement.clientWidth) {
        winWidth = document.documentElement.clientWidth;
    }
    return winWidth;
}

export function isPC() {
    var uaInfo = navigator.userAgent;
    var agents = ["Android", "iPhone", "Windows Phone", "iPad", "iPod"];
    var isPcValue = true;
    var winWidth = getWindowWidth();
    for (var i = 0; i < agents.length; i++) {
        if (uaInfo.indexOf(agents[i]) > 0) {
            isPcValue = false;
            break;
        }
    }
    if (winWidth < 640) {
        isPcValue = false;
    }
    return isPcValue;
}

/***
 * 动态添加script标签
 * @param src  文件路径
 * @param keyWord   关键词，用来排除是否已添加
 * @returns {*}
 */
export function createScript(src,keyWord,callback) {
    if (!keyWord) {
        keyWord = src;
    }
    let jsList = document.getElementsByTagName('script');
    for (let i = 0; i < jsList.length; i++) {
        let jsItem = jsList[i];
        if (jsItem.src && (jsItem.src.indexOf(keyWord) > -1)) {
            if(callback){
                callback();
            }
            return;
        }
    }
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    //document.body.appendChild(el);
    let head = document.getElementsByTagName('head')[0];
    head.appendChild(script);
    script.onload = function(){
        if(callback){
            callback();
        }
    }
}
